import React, { useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

function PrivacyPolicyModal() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start", // Align items to the top
        height: "5vh",
        margin: 0,
        padding: 0,
      }}
    >
      <Box sx={{ marginTop: "auto" }}>
        <Button
          variant="outlined"
          onClick={handleOpen}
          sx={{
            p: "8px 16px",
            m: 0,
            color: "#555", // Plain black text
            border: "none", // Remove border
            fontSize: "16px", // Set font size to 12px
            textTransform: "none", // Keep text normal (no uppercase transformation)
          }}
        >
          Privacy Policy
        </Button>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%", // Set maximum width
            maxWidth: 600, // Limit maximum width
            maxHeight: "80vh", // Limit maximum height
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto", // Enable vertical scroll when needed
            "@media (max-width: 600px)": {
              width: "95%", // Adjust width for smaller screens
            },
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2">
            Privacy Policy
          </Typography>
          <Typography id="modal-description" sx={{ mt: 2 }}>
            <Typography paragraph>
              At Physio-mize, we are committed to protecting your privacy. This
              Privacy Policy outlines how we collect, use, and protect your
              personal health data when using Physio-mize. By using Physio-mize,
              you consent to the collection and use of your data in accordance
              with this policy.
            </Typography>
            <ul>
              <li>
                <b>Data Collection:</b> Physio-mize collects personal health
                data to monitor and enhance your physiotherapy and
                rehabilitation progress. This data includes, but is not limited
                to: Sensor-based motion tracking Exercise performance metrics
                Usage patterns Feedback data from interactions with the device
              </li>
              <li>
                <b>Data Use:</b> The personal health data collected is used for
                the following purposes: To provide real-time feedback on your
                rehabilitation progress To allow your physiotherapist to track
                and adjust your treatment plan To optimize device performance
                based on usage trends For internal analysis to improve future
                iterations of the product
              </li>
              <li>
                <b>Data Sharing:</b> Your data will be shared only with your
                designated physiotherapist to aid in your treatment and
                rehabilitation. No personal data will be sold, rented, or
                disclosed to third parties, except in cases where required by
                law or with your explicit consent.
              </li>
              <li>
                <b>Retention Period:</b> Data will be retained for as long as
                necessary for your rehabilitation and treatment purposes, or as
                required by relevant health regulations. Once it is no longer
                necessary, the data will be securely deleted.
              </li>
              <li>
                <b>User Rights:</b> You have the right to: Access your personal
                data and obtain a copy of it Request corrections to any
                inaccurate data Request the deletion of your data, subject to
                applicable regulations
              </li>
              <li>
                <b>Data Security: </b> We implement security measures, including
                encryption, access control, and secure storage, to protect your
                personal health data from unauthorized access, disclosure, or
                misuse.
              </li>
              <li>
                <b>Device Limitations: </b> As Physio-mize is an engineering
                sample, it is not a certified medical device. While we take all
                precautions to ensure data security, potential vulnerabilities
                inherent in early-stage products may exist. Users are advised to
                follow their physiotherapist's guidance for device usage.
              </li>
              <li>
                <b>Modifications to this Policy: </b> We reserve the right to
                modify this Privacy Policy at any time to reflect changes in our
                practices or legal requirements. Any updates will be
                communicated through the application, and continued use of the
                device constitutes acceptance of these changes.
              </li>
            </ul>
            <Typography>
              By using the Physio-mize device, you acknowledge and agree to this
              Privacy Policy.
            </Typography>
          </Typography>
          <Button onClick={handleClose}>Close</Button>
        </Box>
      </Modal>
    </Box>
  );
}

export default PrivacyPolicyModal;
